import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { getTokenRemainingTime, isTokenExpiringSoon, handleTokenExpiration } from '../../utils/tokenUtils';

const TokenExpirationWarning = ({ auth: { token, isAuthenticated } }) => {
    const [remainingTime, setRemainingTime] = useState(0);
    const isMountedRef = useRef(true);

    useEffect(() => {
        if (!isAuthenticated || !token) {
            return;
        }

        const checkTokenExpiration = () => {
            const remaining = getTokenRemainingTime(token);
            
            // Only update state if component is still mounted
            if (isMountedRef.current) {
                setRemainingTime(remaining);
            }
            
            // Log when token is about to expire or has expired
            if (remaining <= 10 && remaining > 0) {
                console.log(`Token expires in ${remaining} seconds`);
            } else if (remaining === 0) {
                console.log('Token has expired! Triggering logout...');
                handleTokenExpiration();
            }
        };

        // Check immediately
        checkTokenExpiration();

        // Check every second for live countdown
        const interval = setInterval(checkTokenExpiration, 1000);

        return () => {
            clearInterval(interval);
            isMountedRef.current = false;
        };
    }, [token, isAuthenticated]);

    // Don't show if not authenticated or no remaining time
    if (!isAuthenticated || remainingTime <= 0) {
        return null;
    }

    const minutes = Math.floor(remainingTime / 60);
    const seconds = remainingTime % 60;
    const isExpiringSoon = isTokenExpiringSoon(token);

    return (
        <div
            style={{ 
                position: 'fixed', 
                top: 10, 
                left: '50%',
                transform: 'translateX(-50%)',
                backgroundColor: isExpiringSoon ? '#dc3545' : '#17a2b8',
                color: 'white',
                padding: '8px 12px',
                borderRadius: '4px',
                fontSize: '16px',
                fontWeight: 'bold',
                fontFamily: 'monospace',
                zIndex: 9999,
                animation: isExpiringSoon ? 'pulse 1s infinite' : 'none',
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
            }}
        >
            {minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}
            
            <style>{`
                @keyframes pulse {
                    0% { opacity: 1; }
                    50% { opacity: 0.7; }
                    100% { opacity: 1; }
                }
            `}</style>
        </div>
    );
};

const mapStateToProps = state => ({
    auth: state.auth
});

export default connect(mapStateToProps)(TokenExpirationWarning); 